import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  h1: {
    ...theme.rccl.subtitle1,
    color: theme.palette.blue1,
    marginBottom: '20px',
    fontSize: theme.typography.pxToRem(24),
    textTransform: 'capitalize',
    fontFamily: theme.typography.proxima.semiBold,
    borderBottom: `solid 1px ${theme.palette.border}`,
    paddingBottom: '20px',
  },
  tableWrapper: {
    overflow: 'auto',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    position: 'relative',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0,
    },
    [theme.breakpoints.up('lg')]: {
      '&::after': {
        display: 'none', // to remove the blur effect
        content: `''`,
        bottom: '27px',
        position: 'fixed',
        height: '60px',
        width: '292px',
        zIndex: '2',
        backgroundImage: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))',
      },
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'inherit',
    },
  },
  itinerary: {
    padding: '30px 40px',
    paddingLeft: 36,
    width: '100%',
    fontFamily: theme.typography.proxima.regular,
    '& .reservationNumber': {
      color: theme.palette.grey1,
    },
    [theme.breakpoints.down('lg')]: {
      padding: '30px 40px 30px 50px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '30px 40px 30px 50px',
      height: '100%',
      overflow: 'scroll',
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none',
      position: 'relative',
      '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
      },
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: '-16px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '40px 30px',
    },
  },
  card: {
    backgroundColor: 'white',
    boxShadow: '1px 3px 4px -1px rgba(6,21,86,0.10)',
  },
  itInfo: {
    '& span': {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.grey1,
    },
    '& h2': {
      color: theme.palette.grey2,
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.typography.pxToRem(2),
      textTransform: 'capitalize',
      letterSpacing: theme.typography.pxToRem(2),
      fontFamily: theme.typography.proxima.regular,
    },
  },
  itInfoWrapper: {
    '& p:first-child': {
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.typography.pxToRem(20),
    },
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      '& .MuiBox-root:first-child': {
        marginRight: '0',
      },
    },
  },
  itInfoWrapperPayment: {
    '& p:first-child': {
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.typography.pxToRem(20),
    },
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& .MuiBox-root:first-child': {
        marginRight: '0',
      },
    },
  },
  itInlineDate: {
    display: 'flex',
    fontSize: theme.typography.pxToRem(16),
    justifyContent: 'flex-start',
    marginTop: '20px',
    marginBottom: '20px',
    '& .from': {
      marginRight: '4px',
      color: theme.palette.grey1,
      textTransform: 'capitalize',
    },
    '& .to': {
      marginLeft: '4px',
      color: theme.palette.grey1,
      textTransform: 'capitalize',
    },
    '& svg': {
      width: '15px',
      color: theme.palette.grey2,
      position: 'relative',
      bottom: '2px',
    },
  },
  itList: {
    borderTop: `solid 1px ${theme.palette.border}`,
    paddingTop: '20px',
    boxShadow: 'none',
    borderRadius: 0,
    [theme.breakpoints.down('xs')]: {
      paddingTop: '20px',
    },
    '& th': {
      color: theme.palette.blue1,
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(12),
      textTransform: 'capitalize',
      paddingBottom: '8px',
      '&.day': {
        display: 'block',
        marginRight: '10px',
      },
      '&.day, &.port': {
        backgroundColor: 'white',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        [theme.breakpoints.down('sm')]: {
          position: 'inherit',
        },
      },
    },
    '& td': {
      paddingBottom: '24px',
      [theme.breakpoints.down('lg')]: {
        paddingBottom: '23px',
      },
      '&.day': {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.grey2,
        fontFamily: theme.typography.proxima.regular,
      },
      '&.port': {
        '& span': {
          display: 'block',
          fontFamily: theme.typography.proxima.regular,
        },
        '& .city': {
          color: theme.palette.blue1,
          fontSize: theme.typography.pxToRem(16),
          maxWidth: '160px',
        },
        '& .state': {
          color: theme.palette.grey2,
          fontSize: theme.typography.pxToRem(12),
        },
        '& .info': {
          textTransform: 'capitalize',
          fontSize: theme.typography.pxToRem(14),
          color: theme.palette.grey2,
        },
        '& .time': {
          fontSize: theme.typography.pxToRem(14),
          color: theme.palette.grey2,
        },
      },
    },
    '& .info-obx': {
      maxWidth: '300px',
      textAlign: 'left',
      '& p': {
        display: 'inline-block',
        margin: '0',
        maxWidth: '100%',
      },
    },
  },
}));

export default useStyles;
